import { useAuth0 } from '@auth0/auth0-react';
import { useEffect } from "react";

export const LoginWithRedirect = () => {
    const {loginWithRedirect} = useAuth0();

    useEffect(() => {
        loginWithRedirect()
      },[]);  // eslint-disable-line react-hooks/exhaustive-deps

  return <></>;
};
